import { Injectable } from '@angular/core';
import {HttpClient, HttpEvent, HttpEventType} from '@angular/common/http';
import {GlobalService} from '../../global.service';
import {observableToBeFn} from 'rxjs/internal/testing/TestScheduler';

@Injectable({
  providedIn: 'root'
})
export class teamsService {

  constructor(
    private httpClient: HttpClient,
    private globalService: GlobalService
  ) {



  }

  getTeams(sort, direction, page): any {
    return this.httpClient.get(this.globalService.apiUrl + '/teams?page=' + (page) + '&sort=' + sort + '&direction=' + direction);
  }

  saveTeam(team, file) {
    const endpoint = this.globalService.apiUrl + '/teams/save';
    const formData: FormData = new FormData();

    if (file) {
      formData.append('file', file, file.name);
      formData.append('type', 'teamLogo');
    }

    formData.append('teamname', team.teamname);
    formData.append('team_id', team.team_id.toString());
    formData.append('join_password', team.join_password);
    formData.append('teamwebsite', team.teamwebsite);
    formData.append('description', team.description);
    formData.append('teamtwitter', team.teamtwitter);
    formData.append('teamfacebook', team.teamfacebook);
    formData.append('teamyoutube', team.teamyoutube);
    formData.append('teamtwitch', team.teamtwitch);
    formData.append('teaminstagram', team.teaminstagram);
    formData.append('teamspeak', team.teamspeak);
    formData.append('teamdiscord', team.teamdiscord);
    formData.append('founding_date', team.founding_date);
    formData.append('origin', team.origin);
    return this.httpClient.post(endpoint, formData, { observe: 'events' });

  }

  joinTeam(password, team_id) {
    return this.httpClient.post(this.globalService.apiUrl + '/teams/join/' + team_id , {password: password}, {reportProgress: false, observe: 'events'});
  }

  getTeam(id, sim_id = 1) {
    return this.httpClient.get(this.globalService.apiUrl + '/teams/detail/' + id + '?sim_id=' + sim_id, {observe: 'events'});
  }

  getEditTeam(id) {
    return this.httpClient.get(this.globalService.apiUrl + '/teams/edit/' + id, {observe: 'events'});
  }

  removeMember(driver, team) {
    return this.httpClient.post(this.globalService.apiUrl + '/teams/removeMember/' + team + '/' + driver, {});
  }

  makeAdmin(driver, team) {
    return this.httpClient.post(this.globalService.apiUrl + '/teams/makeAdmin/' + team + '/' + driver, {});
  }

  removeAdmin(driver, team) {
    return this.httpClient.post(this.globalService.apiUrl + '/teams/removeAdmin/' + team + '/' + driver, {});
  }

}
